import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import ReactQuill from "react-quill";
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Container, Table } from "react-bootstrap";

// import "./styles.css";
import "font-awesome/css/font-awesome.min.css";
import "react-quill/dist/quill.snow.css";
import 'react-toastify/dist/ReactToastify.css';
import './CardIpPhone.css';

const CardIpPhone = () => {
    const [cardPhones, setPlansTvs] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingPlanoTv, setEditingPlanoTv] = useState(null);
    const [title, setTitle] = useState("");
    const [list, setList] = useState("");
    const [text, setText] = useState("");
    const [obs, setObs] = useState("");
    const [foto, setFoto] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    const TextRender = ({ htmlContent }) => {
        return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
    };

    useEffect(() => {
        fetchPlansTvs();
    }, []);

    const fetchPlansTvs = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/cardPhones`);
            setPlansTvs(response.data);
        } catch (error) {
            console.error("Erro ao buscar os planos:", error);
        }
    };

    const handleOpenModal = () => {
        setIsEditing(false);
        setEditingPlanoTv(null);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setTitle("");
        setList("");
        setText("");
        setObs("");
        setFoto(null);
        setPreviewImage(null);
    };

    const handleEditRural = (cardPhone) => {
        setIsEditing(true);
        setEditingPlanoTv(cardPhone);
        setTitle(cardPhone.title);
        setList(cardPhone.list);
        setText(cardPhone.text);
        setObs(cardPhone.obs);
        setPreviewImage(`${process.env.REACT_APP_API_IMG}/assets/cardPhones/${cardPhone.foto}`);
        setShowModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const handleDeletePlanoTv = async (cardPhoneId) => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/cardPhones/${cardPhoneId}`);
            handleCloseDeleteModal(); // Fechar o modal após a exclusão
            fetchPlansTvs(); // Atualizar a lista de cardPhones

            toast.success('CardPhone deletado com sucesso!', { position: 'top-right', autoClose: 2000 });
        } catch (error) {
            console.error("Erro ao deletar o cardPhone:", error);
        }
    };



    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteModalPlanoTvId, setDeleteModalPlanoTvId] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append("title", title);
        formData.append("list", list);
        formData.append("text", text);
        formData.append("foto", foto);
        formData.append("obs", obs);

        try {
            if (isEditing && editingPlanoTv) {
                await axios.put(`${process.env.REACT_APP_API_URL}/cardPhones/${editingPlanoTv._id}`, formData);
                toast.success('Formulário editado com sucesso!', { position: 'top-right', autoClose: 2000 }); // 3000 milissegundos = 3 segundos
            } else {
                await axios.post(`${process.env.REACT_APP_API_URL}/cardPhones`, formData);
                toast.success('Formulário cadastrado com sucesso!', { position: 'top-right', autoClose: 2000 }); // 3000 milissegundos = 3 segundos
            }

            fetchPlansTvs();
            handleCloseModal();
        } catch (error) {
            console.error("Erro ao cadastrar/editar o cardPhone:", error);
        }
    };

    const handleFotoChange = (event) => {
        const selectedImage = event.target.files[0];

        if (selectedImage) {
            const imageURL = URL.createObjectURL(selectedImage);
            setPreviewImage(imageURL);
            setFoto(selectedImage);
        }
    };

    const [imagemFundo, setImagemFundo] = useState('');

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Novo
        </Tooltip>
    );

    return (
        <Container>
        <div className="row">
            <div className="title">
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                    >
                        <Button variant="outline-primary" size="sm" onClick={handleOpenModal}>
                            <i class="fa fa-plus-square-o" aria-hidden="true"></i>
                        </Button>
                    </OverlayTrigger>
                    <h3><i className="fa fa-fw fa-phone-square" />  Fotos telefone</h3>
                </div>
                <div className="table-container">
                <Table striped bordered hover >
                        <thead>
                            <tr>
                                <th className="coltv">Imagem</th>
                                <th className="coltv1">Título</th>
                                <th className="coltv4">Lista</th>
                                <th className="coltv5">Texto</th>
                                <th className="coltv6">Observação</th>
                                <th className="coltv7">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cardPhones.map((cardPhone) => (
                                <tr key={cardPhone._id}>
                                    <td>
                                        <div className="phone-img">
                                            <img src={`${process.env.REACT_APP_API_IMG}/assets/cardPhones/${cardPhone.foto}`} alt="CardPhone" />
                                        </div>
                                    </td>
                                    <td>{cardPhone.title.slice(0, 50) + "..."}</td>
                                    <td><TextRender htmlContent={cardPhone.list.slice(0, 50) + "..."} /></td>
                                    <td><TextRender htmlContent={cardPhone.text.slice(0, 50) + "..."} /></td>
                                    <td>{cardPhone.obs.slice(0, 50) + "..."}</td>
                                    <td>
                                        <div className="botoes">
                                            <div className="botao">
                                                <Button variant="outline-success" size="sm" onClick={() => handleEditRural(cardPhone)}>
                                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                                </Button>
                                            </div>
                                            <div className="botao">
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => {
                                                        setDeleteModalPlanoTvId(cardPhone._id);
                                                        setShowDeleteModal(true);
                                                    }}
                                                >
                                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                </Button>
                                                <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title>Confirmar Exclusão</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        Tem certeza que deseja excluir este cardPhone? {deleteModalPlanoTvId}
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                                                            Cancelar
                                                        </Button>
                                                        <Button variant="danger" onClick={() => { handleDeletePlanoTv(deleteModalPlanoTvId); setShowDeleteModal(false); }}>
                                                            Excluir
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>

            <div className="row">
                <Modal show={showModal} onHide={handleCloseModal} size="lg" className="custom-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {isEditing ? "Editar CardPhone" : "Cadastrar CardPhone"}
                            <span>Atenção para as dimensões das imagens recomendadas:  (400x400 pixels)</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>

                            <FormGroup>
                                <Form.Label className="form-label">Título</Form.Label>
                                <div className='text-icon-tv'>
                                    <span className="input-group-text" id="addon-wrapping"><i className="fa fa-fw fa-pencil-square-o" style={{ fontSize: "1.0em", color: "#000000" }} /></span>
                                    <FormControl className="custom-form-control" type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <Form.Label>Lista</Form.Label>
                                <div className='text-icon-tv'>
                                    <span className="input-group-text-area" id="addon-wrapping"><i className="fa fa-fw fa-pencil-square-o" style={{ fontSize: "1.0em", color: "#000000" }} /></span>
                                    <ReactQuill value={list} onChange={setList} style={{ width: '100%', height: '80px', marginLeft: '0px' }} required />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <Form.Label>Texto</Form.Label>
                                <div className='text-icon-tv'>
                                    <span className="input-group-text-area" id="addon-wrapping"><i className="fa fa-fw fa-pencil-square-o" style={{ fontSize: "1.0em", color: "#000000" }} /></span>
                                    <ReactQuill value={text} onChange={setText} style={{ width: '100%', height: '80px', marginLeft: '0px' }} required />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <Form.Label>Observação</Form.Label>
                                <div className='text-icon-tv'>
                                    <span className="input-group-text-area" id="addon-wrapping"><i className="fa fa-fw fa-pencil-square-o" style={{ fontSize: "1.0em", color: "#000000" }} /></span>
                                    <ReactQuill value={obs} onChange={setObs} style={{ width: '100%', height: '80px', marginLeft: '0px' }} required />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <div className="foto-preview">
                                    <Form.Label>Foto</Form.Label>
                                    <FormControl type="file" onChange={handleFotoChange} />
                                    {previewImage && <img src={previewImage} className="img-preview" alt="Preview"  style={{width: '200px'}} />}
                                </div>
                            </FormGroup>
                            <br />
                            <Button variant="primary" type="submit">
                                {isEditing ? "Editar" : "Cadastrar"}
                            </Button>{' '}
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Fechar
                            </Button>
                        </Form>
                    </Modal.Body>
                </Modal>

            </div>
        </Container>
    );
};

export default CardIpPhone;